import gql from 'graphql-tag';

export const GQL_LOGOUT = gql`
    mutation {
        logoutApp
    }
`;
